import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import pin from '../../../assets/svg/pin.png';
import './GoogleMap.css';

const Marker = () => <img src={pin} alt="example" className='marker' />

class GoogleMap extends Component {
	static defaultProps = {
		center: {
			lat: 47.369185054229735,
			lng: 8.534818435476836
		},
		zoom: 16
	};

	render() {
		const key = process.env.REACT_APP_GM_API;

		const lat = this.props.contact.map(data => {
			return data.acf.map.lat
		})

		const lng = this.props.contact.map(data => {
			return data.acf.map.lng
		})

		const googleMapAddress = `https://maps.google.com/maps?ll=${lat},${lng}&z=${this.props.zoom}&t=m&hl=en-US&gl=US&mapclient=apiv3`
		const Link = () => <a href={googleMapAddress} className='customAdressLink'>Navigate in Google maps</a>
		const mapOptions = [
			{
				"featureType": "water",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#d3d3d3"
					}
				]
			},
			{
				"featureType": "transit",
				"stylers": [
					{
						"color": "#808080"
					},
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"color": "#b3b3b3"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#ffffff"
					}
				]
			},
			{
				"featureType": "road.local",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"color": "#ffffff"
					},
					{
						"weight": 1.8
					}
				]
			},
			{
				"featureType": "road.local",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#d7d7d7"
					}
				]
			},
			{
				"featureType": "poi",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"color": "#ebebeb"
					}
				]
			},
			{
				"featureType": "administrative",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#a7a7a7"
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#ffffff"
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#ffffff"
					}
				]
			},
			{
				"featureType": "landscape",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"color": "#efefef"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#696969"
					}
				]
			},
			{
				"featureType": "administrative",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"color": "#737373"
					}
				]
			},
			{
				"featureType": "poi",
				"elementType": "labels.icon",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "poi",
				"elementType": "labels",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#d6d6d6"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "labels.icon",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{},
			{
				"featureType": "poi",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#dadada"
					}
				]
			}
		];
		return (
			// Important! Always set the container height explicitly
			<div className='MapWrap'>
				<Link />
				<GoogleMapReact
					bootstrapURLKeys={{ key: key /* YOUR KEY HERE */ }}
					center={this.props.center}
					defaultZoom={this.props.zoom}
					options={{ styles: [...mapOptions] }}>
					<Marker
						lat={lat}
						lng={lng}
						origin={(0, 0)}
					/>
				</GoogleMapReact>
			</div>
		);
	}
}

export default GoogleMap;


// WEBPACK FOOTER //
// ./src/components/Contact/GoogleMap/GoogleMap.js